import styled from 'styled-components';

export default styled.span`
  display: flex;
  align-items: flex-end;
  min-height: 2.25rem;
  text-wrap: balance;
`;
